/* all list - This line cannot be edited or removed */
export const GET_INSPECTIONS = "GET_INSPECTIONS"
export const GET_INSPECTIONS_SUCCESS = "GET_INSPECTIONS_SUCCESS"
export const GET_INSPECTIONS_FAIL = "GET_INSPECTIONS_FAIL"

/* DETAILS */
export const GET_INSPECTION_DETAILS = "GET_INSPECTION_DETAILS"
export const GET_INSPECTION_DETAILS_SUCCESS = "GET_INSPECTION_DETAILS_SUCCESS"
export const GET_INSPECTION_DETAILS_FAIL = "GET_INSPECTION_DETAILS_FAIL"

/* CREATE */
export const CREATE_INSPECTION = "CREATE_INSPECTION"
export const CREATE_INSPECTION_SUCCESS = "CREATE_INSPECTION_SUCCESS"
export const CREATE_INSPECTION_FAIL = "CREATE_INSPECTION_FAIL"

/* Edit */
export const UPDATE_INSPECTION = "UPDATE_INSPECTION"
export const UPDATE_INSPECTION_SUCCESS = "UPDATE_INSPECTION_SUCCESS"
export const UPDATE_INSPECTION_FAIL = "UPDATE_INSPECTION_FAIL"

export const CHECK_INSPECTION_NUMBER = "CHECK_INSPECTION_NUMBER"
export const CHECK_INSPECTION_NUMBER_SUCCESS = "CHECK_INSPECTION_NUMBER_SUCCESS"
export const CHECK_INSPECTION_NUMBER_FAIL = "CHECK_INSPECTION_NUMBER_FAIL"

export const RESET_INSPECTION_STATE = "RESET_INSPECTION_STATE"

// booking
export const GET_INSPECTIONS_BOOKING = "GET_INSPECTIONS_BOOKING"
export const GET_INSPECTIONS_BOOKING_SUCCESS = "GET_INSPECTIONS_BOOKING_SUCCESS"
export const GET_INSPECTIONS_BOOKING_FAIL = "GET_INSPECTIONS_BOOKING_FAIL"

/* DETAILS */
export const GET_INSPECTION_BOOKING_DETAILS = "GET_INSPECTION_BOOKING_DETAILS"
export const GET_INSPECTION_BOOKING_DETAILS_SUCCESS =
  "GET_INSPECTION_BOOKING_DETAILS_SUCCESS"
export const GET_INSPECTION_BOOKING_DETAILS_FAIL =
  "GET_INSPECTION_BOOKING_DETAILS_FAIL"

/* CREATE */
export const CREATE_INSPECTION_BOOKING = "CREATE_INSPECTION_BOOKING"
export const CREATE_INSPECTION_BOOKING_SUCCESS =
  "CREATE_INSPECTION_BOOKING_SUCCESS"
export const CREATE_INSPECTION_BOOKING_FAIL = "CREATE_INSPECTION_BOOKING_FAIL"

/* Edit */
export const UPDATE_INSPECTION_BOOKING = "UPDATE_INSPECTION_BOOKING"
export const UPDATE_INSPECTION_BOOKING_SUCCESS =
  "UPDATE_INSPECTION_BOOKING_SUCCESS"
export const UPDATE_INSPECTION_BOOKING_FAIL = "UPDATE_INSPECTION_BOOKING_FAIL"

export const DELETE_INSPECTION = "DELETE_INSPECTION"
export const DELETE_INSPECTION_SUCCESS = "DELETE_INSPECTION_SUCCESS"
export const DELETE_INSPECTION_FAIL = "DELETE_INSPECTION_FAIL"

//
export const PUT_WHATSAPP_SHARE = "PUT_WHATSAPP_SHARE"
export const PUT_WHATSAPP_SHARE_SUCCESS = "PUT_WHATSAPP_SHARE_SUCCESS"
export const PUT_WHATSAPP_SHARE_FAIL = "PUT_WHATSAPP_SHARE_FAIL"

export const PUT_WHATSAPP_SHARE_PDF = "PUT_WHATSAPP_SHARE_PDF"
export const PUT_WHATSAPP_SHARE_PDF_SUCCESS = "PUT_WHATSAPP_SHARE_PDF_SUCCESS"
export const PUT_WHATSAPP_SHARE_PDF_FAIL = "PUT_WHATSAPP_SHARE_PDF_FAIL"
